var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-component',_vm._b({style:(_vm.containerStyle),attrs:{"link":_vm.component.link}},'cms-component',_vm.$props,false),[_c('i',{staticClass:"glyph-component",class:[_vm.fontAwesomePrefix, _vm.glyph],style:(_vm.glyphStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }